import { getRelatedPublications } from 'common/__content-api/v4/get-related-publications'
import { RelatedPublications } from 'component-library/templates/Publication/Publication.props'
import { mapListPublication } from 'common/__api-mapping/v4/list-publication'
import { DataLoaderGlobalParams } from 'common/data/resources'

/**
 * Gets the related publications for a publication
 */
export async function getRelatedPublicationListing(
    services: DataLoaderGlobalParams,
    publicationId: string
): Promise<RelatedPublications> {
    const relatedPublicationListing = await getRelatedPublications(services, publicationId, {
        paging: { page: 1, pageSize: 10 },
    })

    const itemsToMap = relatedPublicationListing.documents

    const mappedItems = itemsToMap.map(item => mapListPublication(item))

    return {
        items: mappedItems,
    }
}
